<template>
    <div>
        <!-- Mensagem de erro -->
        <v-alert v-if="msg_validar_codigo" type="error">
            {{ msg_validar_codigo }}
        </v-alert>

        <span>
            <v-icon>mdi-information</v-icon>
            Insira o código de validação recebido no seu e-mail
        </span>

        <v-form ref="form_codigo_validacao" class="mt-5">
            <v-otp-input
              v-model.trim="codigo_validacao"
              length="8"
              :rules="[rules.obrigatorio]"
            ></v-otp-input>
        </v-form>

        <div class="text-center mt-3 mb-3">
            <v-btn 
              class="rounded-lg mr-2"
              color="botao_2"
              text
              @click="cancelar()"
            >Cancelar</v-btn>

            <v-btn
              @click="validar_codigo(codigo_validacao)"
              class="rounded-lg"
              color="botao_1"
              dark
            >Proximo</v-btn>
        </div>
    </div>
</template>

<script>
import api from "@/services/api";
import { mapMutations } from "vuex";

export default {
    name: "CodigoValidacao",

    props: {
        email: String,
    },

    data: () => ({
        msg_validar_codigo: "",
        codigo_validacao: "",
        rules: {
            obrigatorio: (v) => !!v || "Este campo é obrigatório",
        },
    }),

    methods: {
        ...mapMutations(["CarregandoMutation"]),

        validar_codigo(codigo_validacao) {
            if (this.$refs.form_codigo_validacao.validate()) {
                this.CarregandoMutation();

                api.get(`perfil/validar-codigo/${this.email}/${codigo_validacao}`)
                .then((response) => {
                    if (response.data.status == 'ok') {
                        this.$emit("form-submit");
                        this.e1 = 3
                        this.msg_validar_codigo = '';
                    } else {
                        this.msg_validar_codigo = response.data.msg;
                    }
                })
                .catch((error) => {
                    console.log(error);
                })
                .finally(() => {
                    this.CarregandoMutation();
                });
            }
        },

        cancelar() {
            this.$emit("cancelar");
        }
    },
}
</script>
